import { Components, Theme } from '@mui/material/styles';

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: theme.spacing(58),
      height: theme.spacing(38),
      padding: theme.spacing(12),
    }),
    thumb: ({ theme }) => ({
      width: theme.spacing(20),
      height: theme.spacing(20),
    }),
    track: ({ theme }) => ({
      borderRadius: theme.spacing(7),
    }),
    switchBase: ({ theme }) => ({
      padding: theme.spacing(9),
      '&.Mui-checked': {
        transform: `translateX(${theme.spacing(20)}) !important`,
      },
    }),
  },
};
